import * as luxon from 'luxon';

import { createFeature, createReducer, on } from '@ngrx/store';

import { OrdDeAllocateSingleActions } from './ord-deallocate-single.actions';

export interface State {
    error: string;
    loaded: boolean;
    loading: boolean;
    data: any;
    receivedTime: string;
}

export const initialState: State = {
    error: null,
    loaded: false,
    loading: false,
    data: [],
    receivedTime: null,
};

export default createFeature({
  name: 'ordDeAllocateSingle',
  reducer: createReducer(
    initialState,
    on(OrdDeAllocateSingleActions.error, (state: State, { error }): State => ({
        ...state,
        error,
        loaded: false,
        loading: false
    })),
    on(OrdDeAllocateSingleActions.reset, (state: State): State => ({
        ...state,
        data: null,
        error: null,
        loaded: false,
        loading: false
    })),
    on(OrdDeAllocateSingleActions.received, (state: State, { result }): State => ({
        ...state,
        data: result,
        error: null,
        loaded: true,
        loading: false,
        receivedTime: luxon.DateTime.now().toISO(),
    })),
  )}
);